import { graphene } from 'graphql/tags'

export const CONNECTED_ACCOUNTS_QUERY = graphene`#graphql
  query connectedAccountsQuery($searchFilter: String) {
    connectedAccounts(filterBy: { displayName: $searchFilter }) {
      edges {
        node {
          ... on RetailerAccount {
            id
            displayName
            locations(filterBy: { primary: true }) {
              edges {
                node {
                  id
                  state
                  city
                }
              }
            }
          }
        }
      }
    }
  }
`

export const INITIAL_CREATE_ORDER_TEMPLATE_QUERY = graphene`#graphql
  query InitialCreateOrderTemplate {
    collections(
      orderBy: [{ field: NAME, order: ASCENDING }]
      filterBy: { archived: false }
    ) {
      edges {
        node {
          id
          name
          code
          archived
        }
      }
    }
    viewerBrand {
      id
      orderEvents(orderBy: [{ field: NAME, order: ASCENDING }]) {
        edges {
          node {
            id
            name
            code
          }
        }
      }
      types {
        edges {
          node {
            id
            name
          }
        }
      }
      priceTypes {
        edges {
          node {
            id
            name
            currency {
              id
              code
            }
          }
        }
      }
    }
  }
`

export const RETAILER_PRICETYPES_AND_DOORS = graphene`#graphql
  query RetailerPriceTypesAndDoors($retailerAccountId: ID!) {
    node(id: $retailerAccountId) {
      ... on RetailerAccount {
        id
        brandDoorMatches {
          edges {
            node {
              id
              code
              name
            }
          }
        }
        priceTypeMatches(orderBy: [{ field: CREATED, order: ASCENDING }]) {
          edges {
            node {
              id
              name
              currency {
                id
                code
              }
            }
          }
        }
      }
    }
  }
`
